import type { PermissionCategory } from "@/features/roles-and-permissions/config/permission-matrix";

/**
 * Eğitim Yöneticisi rolüne UI tarafında yasaklı permission key'leri.
 *
 * Backend bu yetkileri verse bile `usePermission` hook'u false döner; rol
 * oluşturma matrisinde de gösterilmez ve bağımlılık çözümlemesi sırasında
 * eklenseler bile sessizce ayıklanır.
 *
 * Yasaklananlar: kullanıcı ekleme, şifre değiştirme, kullanıcı silme,
 * audit log görüntüleme (hem PAGE hem VIEW).
 */
export const EDUCATION_MANAGER_FORBIDDEN_KEYS: ReadonlySet<string> = new Set([
  "USERS.CREATE",
  "USERS.UPDATE_PASSWORD",
  "USERS.DELETE",
  "AUDIT_LOGS.PAGE",
  "AUDIT_LOGS.VIEW",
]);

/**
 * Eğitim Yöneticisi rolüne UI tarafında otomatik tanınan permission key'leri.
 *
 * Backend bu yetkiyi vermese bile `usePermission` true döner. Sebep:
 * Eğitim Yöneticisi havuza personel ekleyebilmek için tüm personeli
 * görmek zorunda — `USERS.VIEW_ALL` olmadan personel listesi başkanlığına
 * göre filtreleniyor.
 */
export const EDUCATION_MANAGER_IMPLICIT_KEYS: ReadonlySet<string> = new Set([
  "USERS.VIEW_ALL",
]);

/** Yasak key'leri matristen çıkarır. Tamamen boşalan kategorileri eler. */
export function filterMatrixForEducationManager(
  matrix: readonly PermissionCategory[],
): PermissionCategory[] {
  const result: PermissionCategory[] = [];
  for (const cat of matrix) {
    const allowed = cat.permissions.filter(
      (p) => !EDUCATION_MANAGER_FORBIDDEN_KEYS.has(p.key),
    );
    if (allowed.length === 0) continue;
    result.push({ ...cat, permissions: allowed });
  }
  return result;
}

/** Dependency resolve sonucundan yasak key'leri ayıklar. */
export function stripForbiddenForEducationManager(keys: string[]): string[] {
  return keys.filter((k) => !EDUCATION_MANAGER_FORBIDDEN_KEYS.has(k));
}
